var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCareplans(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 13.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#555;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V4TEOI"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.15.5V0h4.7V.5h.08c.8,0,1.6,0,2.4,0a.8.8,0,0,1,.5.23.54.54,0,0,1,.14.45c0,.6,0,1.2,0,1.8v7.07c0,.74,0,1.48,0,2.21a2.81,2.81,0,0,1,0,.29.57.57,0,0,1-.25.39.53.53,0,0,1-.35.12H.53a.19.19,0,0,1-.1,0,.71.71,0,0,1-.29-.23A.56.56,0,0,1,0,12.5c0-.59,0-1.18,0-1.77V4.38c0-1,0-1.92,0-2.88C0,1.34,0,1.17,0,1A.48.48,0,0,1,.25.67.73.73,0,0,1,.71.51c.78,0,1.57,0,2.36,0Zm4.7,2.1H3.15c0-.15,0-.29,0-.44s0-.07-.08-.07H1.85v9.14h7.3V2.1H7.85Zm1.83-1V11.77H1.32V1.56H3.14V1.05H1.34l-.67,0c-.11,0-.12,0-.12.13,0,.42,0,.85,0,1.28V11.6c0,.27,0,.54,0,.81,0,.1,0,.12.12.12H1l1.75,0H9.19l1.14,0c.1,0,.11,0,.12-.12s0-.25,0-.38c0-.48,0-1,0-1.44V2c0-.27,0-.54,0-.81,0-.1,0-.11-.11-.12H7.92c-.06,0-.07,0-.07.07v.37a.22.22,0,0,0,0,.08ZM7.33.52H3.76c-.07,0-.09,0-.09.09,0,.47,0,1,0,1.43v0H7.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.11,9.94v.49s0,0,0,0H3c-.06,0-.08,0-.08-.08V9.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.89,8.63H8c.09,0,.09,0,.09.09v.35c0,.06,0,.08-.07.08H3c-.09,0-.09,0-.09-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.89,7.34H8.11v.47l-.06,0H3c-.08,0-.09,0-.09-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.18,6H3.67V5.24H2.89V4.76s0-.06.07-.06h.7V3.93h.53V4c0,.2,0,.41,0,.62,0,0,0,.07.07.07h.65s.07,0,.07.07a2.41,2.41,0,0,0,0,.38s0,.06-.07.06H4.27c-.06,0-.07,0-.08.07,0,.23,0,.45,0,.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.11,5.23H5.84c-.07,0-.09,0-.09-.09a2.41,2.41,0,0,0,0-.38c0-.06,0-.07.08-.07H8.06s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.11,3.93H5.84c-.06,0-.08,0-.08-.07s0-.26,0-.39,0-.07.06-.07H8c.05,0,.07,0,.07.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.94,6H8c.05,0,.07,0,.07.07v.38s0,.06-.06.06H5.82c-.05,0-.07,0-.07-.07a2.29,2.29,0,0,0,0-.37c0-.06,0-.08.07-.07Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareplans);
export default __webpack_public_path__ + "static/media/Careplans.4adf63cedbcdf297f24cc03ebc135193.svg";
export { ForwardRef as ReactComponent };